import React, { Component } from 'react';
import cx from 'classnames';
import CLOSE from 'assets/img/close.svg';
import './style.scss';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidUpdate() {
    const { visible } = this.state;
    document.body.style.overflow = visible ? 'hidden' : 'auto';
  }

  closeInternalHandlers = (e) => {
    if (e.target.className === 'background' || e.target.className === 'cross') {
      this.setState({ visible: false });
    }
    return false;
  };

  open = () => this.setState({ visible: true });

  close = () => this.setState({ visible: false });

  render() {
    const { children, addressDetails } = this.props;
    const { visible } = this.state;

    return (
      <div className={cx('modal', {
        visible,
        addressDetails,
      })}
      >
        <div className="background" onClick={e => this.closeInternalHandlers(e)}>

          <div className={cx('wrapper', {
            visible,
          })}
          >
            <div className="header">
              <img className="cross" onClick={e => this.closeInternalHandlers(e)} src={CLOSE} alt="CLOSE" />
            </div>
            <div className="body">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { Modal };



// WEBPACK FOOTER //
// ./src/view/common/Modal/index.jsx